<template>
    <div class="page m-omitStats">


        <el-tabs class="omit-tab" v-model="tab" type="border-card">
            <el-tab-pane label="安检员漏检统计" name="1">
                <omit-security v-if="tab==1"></omit-security>
            </el-tab-pane>
            <el-tab-pane label="机构漏检统计" name="2">
                <omit-organization v-if="tab==2"></omit-organization>
            </el-tab-pane>
            <el-tab-pane label="漏检旅客统计" name="3">
                <omit-passenger v-if="tab==3"></omit-passenger>
            </el-tab-pane>
        </el-tabs>

        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import OmitSecurity from "./OmitUser"
    import OmitOrganization from "./OmitOrganization"
    import OmitPassenger from "./OmitPassenger"

    export default {
        components: {
            OmitSecurity,
            OmitOrganization,
            OmitPassenger,
        },
        data() {
            return {
                tab: '1'
            }
        },
        computed: {},
        mounted() {

        },
        methods: {},
    }
</script>

<style lang="scss">
    @import "~@/style/const";
    $chartHeight: 320px;

    .m-omitStats {
        .omit-tab {
            > .el-tabs__content{
                padding: 20px 30px;
            }
        }

        .ui-card {
            box-shadow: none;
            border: 1px solid #dedede;
        }

        // 组织机构
        .box-org {
            height: $chartHeight;
            .card-body {
                height: $chartHeight;
            }
        }

        // 解决二级页面晃动问题
        .sub-page {
            > .el-main {
                overflow-x: hidden;
            }
        }

        .table-query {
            padding: 20px 0 10px 10px;
        }

        .slideInRight {
            animation-duration: 300ms;
        }
    }
</style>
